import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const commentsResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  let comments
  if (widgetType && widgetType === WidgetType.SOCIAL_WEB_POPULAR_POSTS) {
    comments = metadata.getComments()
  }

  return { comments } as StreamData
}

export default commentsResolver
